import { createContext } from 'react';
import { Logger } from '@gplibraries/react/utils';
export const LoggerContext = createContext(new Logger());
